/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Video_File_HelpInputs */

const en_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a MP4, MOV, GXF, MPEG, or MXF video file`)
};

const fr_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un fichier video MP4, MOV, GXF, MPEG ou MXF`)
};

const de_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine MP4-, MOV-, GXF-, MPEG- oder MXF-Videodatei aus.`)
};

const it_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file video MP4, MOV, GXF, MPEG o MXF`)
};

const ru_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите видеофайл в формате MP4, MOV, GXF, MPEG или MXF.`)
};

const es_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un archivo de vídeo MP4, MOV, GXF, MPEG o MXF`)
};

const zh_cn2_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 MP4、MOV、GXF、MPEG 或 MXF 视频文件`)
};

const ja_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP4、MOV、GXF、MPEG、またはMXFビデオファイルを選択します`)
};

const hi_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक MP4, MOV, GXF, MPEG या MXF वीडियो फ़ाइल चुनें`)
};

const pt_pt2_embed_captions_video_file_help = /** @type {(inputs: Embed_Captions_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um arquivo de vídeo MP4, MOV, GXF, MPEG ou MXF.`)
};

/**
* | output |
* | --- |
* | "Select a MP4, MOV, GXF, MPEG, or MXF video file" |
*
* @param {Embed_Captions_Video_File_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_video_file_help = /** @type {((inputs?: Embed_Captions_Video_File_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Video_File_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_video_file_help(inputs)
	if (locale === "de") return de_embed_captions_video_file_help(inputs)
	if (locale === "it") return it_embed_captions_video_file_help(inputs)
	if (locale === "ru") return ru_embed_captions_video_file_help(inputs)
	if (locale === "es") return es_embed_captions_video_file_help(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_video_file_help(inputs)
	if (locale === "ja") return ja_embed_captions_video_file_help(inputs)
	if (locale === "hi") return hi_embed_captions_video_file_help(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_video_file_help(inputs)
	return en_embed_captions_video_file_help(inputs)
});